import { useRouter } from 'next/router'
import { Loading } from '@/components/icon'
import { GetVoiceNextResponse } from '@/types/voice'
import { useEffect } from 'react'

interface Props {
  next?: GetVoiceNextResponse
  onClose: () => void
  onNext: () => void
}

export const NextVoiceModal: React.FC<Props> = ({ next, onClose, onNext }) => {
  const router = useRouter()
  const buttonStyle =
    'p-[5px_10px] m-1 text-xs text-white bg-fl-blue rounded hover:bg-fl-indigo'

  useEffect(() => {
    const timer = setTimeout(() => {
      onClose()
      router.push(`/summary/${next?.summary.id}`)
    }, 5000)
    return () => {
      clearTimeout(timer)
    }
  }, [])

  return (
    <div className="p-4 text-center">
      <Loading className="my-0 mx-auto" />
      <div>続けて要約を再生する</div>
      <img
        src={next?.summary?.image}
        alt={next?.summary?.title}
        className="mx-auto mt-2 mb-6 w-[130px] shadow-flier"
      />
      <div className="flex justify-center">
        <button className={buttonStyle} onClick={onClose}>
          停止
        </button>
        <button
          className={buttonStyle}
          onClick={() => router.push(`/summary/${next?.summary.id}`)}
        >
          再生
        </button>
        <button className={buttonStyle} onClick={onNext}>
          さらに次の要約
        </button>
      </div>
    </div>
  )
}
